import { publicComponentOption } from "dependencies/base"
import { toSelectOpt } from "utils"
const optDes = {
  ...publicComponentOption,
  isShowTabs: "显示tab",
  isShowTitle: "显示标题",
  isShowMoreBtn: "显示更多",
  activeIndex: "选中的tab页",
  borderTopLeftRadius: "左上边框圆角",
  borderTopRightRadius: "右上边框圆角",
  borderBottomLeftRadius: "坐下边框圆角",
  borderBottomRightRadius: "右下边框圆角",
  borderStyle: "边框类型",
  borderColor: "边框颜色",
  borderWidth: "边框宽度",
  boxShadowColor: "阴影颜色",
  boxShadowH: "阴影x轴偏移量",
  boxShadowV: "阴影y轴偏移量",
  boxShadowBlur: "阴影模糊值",
  boxShadowSpread: "阴影扩散值",
  clipSize: "背景裁剪方式",
  repeatType: "背景重复方式",
  alignType: "背景对齐方式",
  imgSrc: "背景图链接",
  noCacheComponent: "非缓存组件",
  updateTimer: "数据轮询时间",
  restDataUrl: "外接数据源地址",
  reverseGetColsUid: "翻转更新",
  queryColValue: "响应数据值"
}
export const getOptDes = toSelectOpt.bind(this, optDes)
